module.exports = __webpack_public_path__ + "static/media/loader.b9bef14f.svg";